import '@fpsm/cxy-tokens/tokens.css';

import { CxFooterLean } from '@cx-web/components/composites';
import { type FooterV2Response } from '@cx-web/domain-types';

import { type Logos } from '~/routes/$/constants/logos';

import { LogoImage } from '../LogoImage/LogoImage';

import styles from './LandingPageFooter.module.css';

export type LandingPageFooterProps = {
  footerData?: FooterV2Response;
  logo: Logos;
  resourcesUrl: string;
};

export const LandingPageFooter = ({ footerData, logo, resourcesUrl }: LandingPageFooterProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.divider}>
        <div />
      </div>
      <CxFooterLean
        footerData={footerData}
        isAdmiralCookieBannerEnabled={false}
        logo={<LogoImage logoName={logo} resourcesUrl={resourcesUrl} />}
      />
    </div>
  );
};
